(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((disclosure) => disclosure.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovena-pdp"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ovp').forEach(function (root) {
    var dataEl = root.querySelector('[data-ovp-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-ovp-id]');
    var priceEl = root.querySelector('[data-ovp-price]');
    var addBtn = root.querySelector('[data-ovp-add]');
    var addText = root.querySelector('[data-ovp-add-text]');
    var money = function (cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    function setActive(idx) {
      root.querySelectorAll('[data-ovp-slide]').forEach(function (m) {
        m.classList.toggle('is-active', m.getAttribute('data-ovp-slide') === idx);
      });
      root.querySelectorAll('[data-ovp-thumb]').forEach(function (x) {
        x.classList.toggle('is-active', x.getAttribute('data-ovp-thumb') === idx);
      });
    }
    function selectedValues() {
      var sel = [];
      root.querySelectorAll('[data-ovp-opt]:checked').forEach(function (r) { sel.push(r.value.toLowerCase()); });
      return sel;
    }
    function filterGallery() {
      var sel = selectedValues();
      var slides = root.querySelectorAll('[data-ovp-slide]');
      var anyMatch = false;
      slides.forEach(function (m) {
        var g = (m.getAttribute('data-ovp-group') || '').toLowerCase();
        if (g !== '' && sel.indexOf(g) !== -1) anyMatch = true;
      });
      var shows = function (g) {
        g = (g || '').toLowerCase();
        if (!anyMatch) return true;
        return g === '' || sel.indexOf(g) !== -1;
      };
      var firstVisible = null;
      slides.forEach(function (m) {
        if (shows(m.getAttribute('data-ovp-group')) && firstVisible === null) {
          firstVisible = m.getAttribute('data-ovp-slide');
        }
      });
      root.querySelectorAll('[data-ovp-thumb]').forEach(function (t) {
        t.style.display = shows(t.getAttribute('data-ovp-group')) ? '' : 'none';
      });
      document.querySelectorAll('[data-ovp-bandgroup]').forEach(function (b) {
        var bg = (b.getAttribute('data-ovp-bandgroup') || '').toLowerCase();
        var show = bg === '';
        if (!show) { bg.split(',').forEach(function (g) { if (sel.indexOf(g.trim()) !== -1) { show = true; } }); }
        b.style.display = show ? '' : 'none';
      });
      if (firstVisible !== null) setActive(firstVisible);
    }
    function update() {
      var opts = selectedValues();
      var match = variants.find(function (v) {
        for (var i = 0; i < opts.length; i++) {
          if ((v.options[i] || '').toLowerCase() !== opts[i]) return false;
        }
        return true;
      });
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        var onePriceEl = root.querySelector('[data-ovp-oneprice]');
        var subPriceEl = root.querySelector('[data-ovp-subprice]');
        if (onePriceEl) onePriceEl.textContent = money(match.price);
        if (subPriceEl) subPriceEl.textContent = money(Math.round(match.price * 0.9));
        var unitsEl = document.querySelector('[data-ovp-units]');
        if (unitsEl) { var utpl = unitsEl.getAttribute('data-ovp-units-tpl') || ''; if (utpl) { var usz = (match.options[0] || ''); if (/^\d+x\d+$/.test(usz)) { usz = usz.replace('x', '"x') + '"'; } unitsEl.textContent = utpl.replace('~v~', usz); } }
        if (addBtn) addBtn.disabled = !match.available;
        if (addText) addText.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      filterGallery();
    }
    root.querySelectorAll('[data-ovp-opt]').forEach(function (r) { r.addEventListener('change', update); });
    // options carry data-ovp-opt so :checked still finds them, but change
    // fires on the select — bind that too or the variant never switches
    root.querySelectorAll('[data-ovp-optsel]').forEach(function (s) { s.addEventListener('change', update); });
    root.querySelectorAll('[data-ovp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { setActive(t.getAttribute('data-ovp-thumb')); });
    });
    // Finger-swipe the main gallery image to move through photos (mobile)
    var stage = root.querySelector('.ovp__stage');
    if (stage) {
      var _sx = 0, _sy = 0, _tr = false;
      var visIdx = function () {
        var out = [];
        root.querySelectorAll('[data-ovp-thumb]').forEach(function (t) { if (t.style.display !== 'none') out.push(t.getAttribute('data-ovp-thumb')); });
        return out;
      };
      var curIdx = function () {
        var a = root.querySelector('[data-ovp-thumb].is-active') || root.querySelector('[data-ovp-slide].is-active');
        return a ? (a.getAttribute('data-ovp-thumb') || a.getAttribute('data-ovp-slide')) : null;
      };
      var go = function (dir) {
        var list = visIdx(); if (!list.length) return;
        var i = list.indexOf(curIdx()); if (i === -1) i = 0;
        var n = i + dir; if (n < 0) n = list.length - 1; if (n >= list.length) n = 0;
        setActive(list[n]);
      };
      stage.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) return; _sx = e.touches[0].clientX; _sy = e.touches[0].clientY; _tr = true; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (!_tr) return; _tr = false; var dx = e.changedTouches[0].clientX - _sx, dy = e.changedTouches[0].clientY - _sy; if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return; go(dx < 0 ? 1 : -1); }, { passive: true });
    }
    filterGallery();
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovena-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ovp').forEach(function (root) {
    var dataEl = root.querySelector('[data-ovp-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-ovp-id]');
    var priceEl = root.querySelector('[data-ovp-price]');
    var addBtn = root.querySelector('[data-ovp-add]');
    var addText = root.querySelector('[data-ovp-add-text]');
    var money = function (cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    function setActive(idx) {
      root.querySelectorAll('[data-ovp-slide]').forEach(function (m) {
        m.classList.toggle('is-active', m.getAttribute('data-ovp-slide') === idx);
      });
      root.querySelectorAll('[data-ovp-thumb]').forEach(function (x) {
        x.classList.toggle('is-active', x.getAttribute('data-ovp-thumb') === idx);
      });
    }
    function selectedValues() {
      var sel = [];
      root.querySelectorAll('[data-ovp-opt]:checked').forEach(function (r) { sel.push(r.value.toLowerCase()); });
      return sel;
    }
    function filterGallery() {
      var sel = selectedValues();
      var slides = root.querySelectorAll('[data-ovp-slide]');
      var anyMatch = false;
      slides.forEach(function (m) {
        var g = (m.getAttribute('data-ovp-group') || '').toLowerCase();
        if (g !== '' && sel.indexOf(g) !== -1) anyMatch = true;
      });
      var shows = function (g) {
        g = (g || '').toLowerCase();
        if (!anyMatch) return true;
        return g === '' || sel.indexOf(g) !== -1;
      };
      var firstVisible = null;
      slides.forEach(function (m) {
        if (shows(m.getAttribute('data-ovp-group')) && firstVisible === null) {
          firstVisible = m.getAttribute('data-ovp-slide');
        }
      });
      root.querySelectorAll('[data-ovp-thumb]').forEach(function (t) {
        t.style.display = shows(t.getAttribute('data-ovp-group')) ? '' : 'none';
      });
      if (firstVisible !== null) setActive(firstVisible);
    }
    function update() {
      var opts = selectedValues();
      var match = variants.find(function (v) {
        for (var i = 0; i < opts.length; i++) {
          if ((v.options[i] || '').toLowerCase() !== opts[i]) return false;
        }
        return true;
      });
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (addBtn) addBtn.disabled = !match.available;
        if (addText) addText.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      filterGallery();
    }
    root.querySelectorAll('[data-ovp-opt]').forEach(function (r) { r.addEventListener('change', update); });
    root.querySelectorAll('[data-ovp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { setActive(t.getAttribute('data-ovp-thumb')); });
    });
    filterGallery();
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.getElementById('ovq-wrap');
  if (!wrap) return;
  var steps = wrap.querySelectorAll('.ovq-step');
  var answers = {};
  function show(step) {
    steps.forEach(function (s) { s.hidden = s.getAttribute('data-step') !== step; });
  }
  function applyRecommendation() {
    var t = document.getElementById('ov-quiz-rec-title');
    var d = document.getElementById('ov-quiz-rec-desc');
    var l = document.getElementById('ov-quiz-rec-link');
    if (answers.condition === 'compression') {
      t.textContent = 'Compression Socks';
      d.textContent = '20-30 mmHg graduated compression socks.';
      l.href = wrap.dataset.recCompression;
    } else if (answers.condition === 'blister') {
      t.textContent = 'Hydrocolloid Roll';
      d.textContent = 'Cut-to-size hydrocolloid for blisters, small wounds, and pimples. Single roll lasts ~50 patches.';
      l.href = wrap.dataset.recBlister;
    } else if (answers.condition === 'mobility') {
      t.textContent = 'Sock Aid + Compression Bundle';
      d.textContent = 'Long-handle sock aid donning device + 2 pairs of compression socks. For arthritis, post-hip / knee replacement.';
      l.href = wrap.dataset.recMobility;
    } else {
      t.textContent = 'Complete Wound Care Kit (4×4)';
      d.textContent = 'Best for caregivers managing a slow-healing wound. Includes 5 sterile collagen pads, saline wash, medical tape, gloves, and instruction card.';
      l.href = wrap.dataset.recWound;
    }
  }
  wrap.querySelectorAll('.ovq-opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pair = btn.getAttribute('data-store').split('=');
      answers[pair[0]] = pair[1];
      var next = btn.getAttribute('data-next');
      if (next === 'result') applyRecommendation();
      show(next);
    });
  });
  var restart = document.getElementById('ovq-restart');
  if (restart) restart.addEventListener('click', function () { answers = {}; show('1'); });
})();

  } catch(e) { console.error(e); }
})();
})();
